import { render, staticRenderFns } from "./LogsCommentsTimeline.vue?vue&type=template&id=6582e2e9&scoped=true"
import script from "./LogsCommentsTimeline.vue?vue&type=script&lang=js"
export * from "./LogsCommentsTimeline.vue?vue&type=script&lang=js"
import style0 from "./LogsCommentsTimeline.vue?vue&type=style&index=0&id=6582e2e9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6582e2e9",
  null
  
)

export default component.exports